import { PanelMenuDesignTokens } from '@primeuix/themes/types/panelmenu';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/panelmenu/index.ts
const pm = componentCommon.panelmenu;
const pmDeep = tDeep(pm);

export const PanelmenuTelekomDT: PanelMenuDesignTokens = {
  root: {
    gap: t(pm.gap),
  },
  panel: {
    background: t(pm.panel.background),
    borderColor: t(pm.panel.border.color),
    borderWidth: tNum(pm.panel.border.width),
    color: t(pm.panel.color),
    padding: `${pmDeep.panel.padding.y} ${pmDeep.panel.padding.x}`,
    borderRadius: t(pm.panel.border.radius),
    first: {
      borderWidth: tNum(pm.panel.first.border.width),
      topBorderRadius: t(pm.panel.first.top.border.radius),
    },
    last: {
      borderWidth: tNum(pm.panel.last.border.width),
      bottomBorderRadius: t(pm.panel.last.bottom.border.radius),
    },
  },
  item: {
    focusBackground: t(pm.item.focus.background),
    color: t(pm.item.color),
    focusColor: t(pm.item.focus.color),
    gap: t(pm.item.gap),
    padding: `${pmDeep.item.padding.y} ${pmDeep.item.padding.x}`,
    borderRadius: t(pm.item.border.radius),
    icon: {
      color: t(pm.item.icon.color),
      focusColor: t(pm.item.icon.focus.color),
    },
  },
  submenu: {
    indent: t(pm.submenu.indent),
  },
  submenuIcon: {
    color: t(pm.submenu.icon.color),
    focusColor: t(pm.submenu.icon.focus.color),
  },
};
